import { TypographyOptions } from '@mui/material/styles/createTypography';

export const posTypographyWithFontFamily = (fontFamily: string): TypographyOptions => ({
	htmlFontSize: 10,
	fontFamily: fontFamily,
	allVariants: {
		fontSize: '1.6rem',
	},
	h1: {
		fontSize: '1.9rem',
		fontWeight: 700,
	},
	h2: {
		fontSize: '1.8rem',
		fontWeight: 700,
	},
	h3: {
		fontSize: '1.7rem',
		fontWeight: 700,
	},
	h4: {
		fontSize: '1.6rem',
		fontWeight: 700,
	},
	h5: {
		fontSize: '1.4rem',
		fontWeight: 700,
	},
	h6: {
		fontSize: '1.2rem',
		fontWeight: 700,
	},
	subtitle1: {
		fontSize: '1.5rem',
	},
	subtitle2: {
		fontSize: '1.4rem',
	},
	body1: {
		fontSize: '1.3rem',
	},
	body2: {
		fontSize: '1.2rem',
	},
	caption: {
		fontSize: '1rem',
	},
});

export const waitingTypographyWithFontFamily = (fontFamily: string): TypographyOptions => ({
	htmlFontSize: 10,
	fontFamily: fontFamily,
	allVariants: {
		fontSize: '2.0rem',
	},
	h1: {
		fontSize: '2.4rem',
		fontWeight: 700,
	},
	h2: {
		fontSize: '2.2rem',
		fontWeight: 700,
	},
	h3: {
		fontSize: '2.0rem',
		fontWeight: 700,
	},
	h4: {
		fontSize: '1.8rem',
		fontWeight: 700,
	},
	h5: {
		fontSize: '1.7rem',
		fontWeight: 700,
	},
	h6: {
		fontSize: '1.3rem',
		fontWeight: 700,
	},
	subtitle1: {
		fontSize: '1.5rem',
	},
	subtitle2: {
		fontSize: '1.4rem',
	},
	body1: {
		fontSize: '1.5rem',
	},
	body2: {
		fontSize: '1.3rem',
	},
	caption: {
		fontSize: '1.5rem',
	},
});
